export default __webpack_public_path__ + "static/media/ok-circle.9d13c257.svg";